import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-end',
      flexDirection: 'row',
    },

    '& .MuiInputBase-root.Mui-disabled': {
      color: 'black',
    },
    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: 'black',
    },
  },

  cardSubList: {
    display: 'flex',
    flexDirection: 'column',

    '& div': {
      border: 'none',
      backgroundColor: '#efefef',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
    },

    '& .MuiFab-sizeSmall': {
      minHeight: 30,
      maxHeight: 30,
      minWidth: 30,
      maxWidth: 30,
      margin: 5,
    },
  },

  name: {
    marginTop: 10,
  },

  url: {
    flexGrow: 1,
    marginTop: 10,

    [theme.breakpoints.up('lg')]: {
      width: 'auto',
    },
  },
}));

export default useStyles;
